import { render } from "./ContractListRecent.vue?vue&type=template&id=1e89edca&scoped=true&ts=true"
import script from "./ContractListRecent.vue?vue&type=script&lang=ts"
export * from "./ContractListRecent.vue?vue&type=script&lang=ts"

import "./ContractListRecent.vue?vue&type=style&index=0&id=1e89edca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e89edca"]])

export default __exports__